// extracted by mini-css-extract-plugin
export default {"titleContainer":"SimilarProfilesContainer_titleContainer__nYOtC"};